// extracted by mini-css-extract-plugin
export var closeIcon = "dialog-module--close-icon--b5c66";
export var dialogButtons = "dialog-module--dialog-buttons--7a12e";
export var dialogCancelButton = "dialog-module--dialog-cancel-button--12a82";
export var dialogConfirmButton = "dialog-module--dialog-confirm-button--d976c";
export var dialogContainer = "dialog-module--dialog-container--aa104";
export var dialogContent = "dialog-module--dialog-content--f1279";
export var dialogDescription = "dialog-module--dialog-description--f98ee";
export var dialogDescriptionContainer = "dialog-module--dialog-description-container--fd381";
export var dialogHeader = "dialog-module--dialog-header--88bb0";
export var dialogHeaderContent = "dialog-module--dialog-header-content--9d0cd";
export var dialogTitle = "dialog-module--dialog-title--8b61d";
export var dialogVisible = "dialog-module--dialog-visible--fdcae";